import { tutorialAssets } from "assets/cdn";
import { useImagePath } from "hooks/useImagePath";
import { useMediaQuery } from "@mui/material";
import useDIPCalculateScale from "components/DIP/hooks/useDIPCalculateScale";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useAppDispatch, useAppSelector } from "hooks";
import { debounce } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useEffectOnce } from "react-use";
import { onDIPtrigger, selectDipState } from "redux/slices";
import { Background1, Text, Tiki1 } from "../../styles";
import { Container } from "./style";
import { Triangle } from "./Triangle";

interface Slide3Props {
	onNext: () => void;
}

export const Slide3 = ({ onNext }: Slide3Props) => {
	const { getImage } = useImagePath("cdn");
	const tiki = getImage(tutorialAssets.char1);
	const dispatch = useAppDispatch();
	const containerRef = useRef<HTMLDivElement>(null);
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const [hasSeenDip, setHasSeenDip] = useState<boolean>(false);
	const { currentDip, opened } = useAppSelector(selectDipState);
	const scale = useCalculateScale(
		isPortrait ? 400 : 700,
		isPortrait ? 800 : 430
	);
	const dipScale = useDIPCalculateScale();

	const [tutorialPosition, setTutorialPosition] = useState<{
		bottom: number;
		left: number;
	}>({ bottom: 0, left: 0 });

	const positionAfterWindowChange = () => {
		if (containerRef?.current && currentDip) {
			const dipElement = document.getElementById(currentDip.dip.id);
			const rectDIP = dipElement?.getBoundingClientRect();
			if (!rectDIP) {
				return;
			}
			const rect = containerRef.current.getBoundingClientRect();
			const leftPosition = isPortrait
				? (window.innerWidth - rect.width) / 2 // * (scale < 1 ? 1 - scale : 1)
				: rectDIP.left * dipScale;
			const bottomPosition = rectDIP.bottom - rectDIP.height - rect.height / 6; //* (scale < 1 ? 1 - scale : 1);
			setTutorialPosition({
				bottom: bottomPosition,
				left: leftPosition
			});
			setHasSeenDip(true);
		}
	};

	useEffectOnce(() => {
		dispatch(onDIPtrigger({ triggerType: "loyaltyFtueOfferQualified" }));
	});

	useEffect(() => {
		/* if (opened) {
			// timeout to wait for DIP to transition in
			setHasSeenDip(true);
		} */
		if (!opened && hasSeenDip) {
			onNext();
		}
	}, [opened]);

	const debouncedHandlePosition = debounce(positionAfterWindowChange, 200);

	useEffect(() => {
		if (currentDip?.dip) {
			// timeout to wait for DIP to transition in
			setTimeout(() => {
				positionAfterWindowChange();
			}, 300);
		}
	}, [currentDip?.dip?.id]);

	useEffect(() => {
		window.addEventListener("resize", debouncedHandlePosition);
		window.addEventListener("transitionend", debouncedHandlePosition);

		return () => {
			window.removeEventListener("resize", debouncedHandlePosition);
			window.removeEventListener("transitionend", debouncedHandlePosition);
		};
	}, [
		//scale,
		//dipScale,
		//opened,
		currentDip?.dip?.id,
		//containerRef?.current,
		isPortrait,
		window.innerWidth,
		window.innerHeight
	]);

	return (
		<>
			<Container
				ref={containerRef}
				scale={scale}
				left={tutorialPosition.left}
				bottom={tutorialPosition.bottom}
				show={hasSeenDip}
			>
				<Tiki1 src={tiki} alt="Mr. Tiki" />
				<Background1>
					<Triangle />
					<Text
						color="#462C12"
						fontFamily="Inter"
						fontSize="16px"
						fontWeight={700}
						style={{ lineHeight: "18px" }}
					>
						Kickstart your Loyalty Points journey with an AMAZING one-time
						offer!
					</Text>
					{/* <Text
						color="#462C12"
						fontFamily="Inter"
						fontSize="12px"
						fontWeight={400}
						lineHeight="15px"
					>
						{isPortrait ? (
							<>
								Your Rewards appear instantly on
								<br /> your balance.
							</>
						) : (
							<>Your Rewards appear instantly on your balance.</>
						)}
					</Text> */}
				</Background1>
			</Container>
		</>
	);
};
